import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import t from '../../lib/I18n';
import PaypalPayment from '../../records/order/PaypalPayment';

function PaypalPaymentDetails ({ payment, small }) {
    const logo = small ? 'pp-acceptance-small.png' : 'PP_logo_h_100x26.png';

    return (
        <span className={ classnames('payment__paypal', { 'payment__paypal--small': small }) }>
            <img src={ `https://www.paypalobjects.com/webstatic/en_US/i/buttons/${logo}` } alt="PayPal" />
            <span className="payment__paypal-account">{ t('payment.details.paypal', { paypalAccount: payment.paypalAccount }) }</span>
        </span>
    );

}

PaypalPaymentDetails.propTypes = {
    payment: PropTypes.instanceOf(PaypalPayment).isRequired,
    small: PropTypes.bool
};

PaypalPaymentDetails.defaultProps = {
    small: false
};

export default PaypalPaymentDetails;
